import axios from 'axios'

export default {
    create(data) {
        return axios.post(`/unauthenticated/logs-tracker`, data)
    },
}
